import { get, patch } from '@/lib/api';

export type LegalForm = 'OOO' | 'IP' | 'SAMOZANYATY' | 'AO';
export type TaxSystem = 'OSN' | 'USN' | 'NPD';
export type PaymentTerms = 'PREPAY' | 'ON_DELIVERY' | 'DEFERRED';
export type SupplierStatus = 'PENDING' | 'ACTIVE' | 'BLOCKED';
export type SubStatus = 'TRIAL' | 'ACTIVE' | 'PAST_DUE' | 'CANCELLED';

export interface SupplierProfile {
  id: string;
  email: string;
  name: string;
  phone: string | null;
  logoUrl: string | null;
  description: string | null;
  city: string | null;
  status: SupplierStatus;

  legalForm: LegalForm | null;
  legalName: string | null;
  inn: string | null;
  kpp: string | null;
  ogrn: string | null;
  taxSystem: TaxSystem | null;
  legalAddress: string | null;
  warehouseAddress: string | null;
  contactPerson: string | null;

  bankAccount: string | null;
  bik: string | null;
  bankName: string | null;
  corrAccount: string | null;

  tags: string[];
  deliveryRegions: string[];
  deliverySchedule: string | null;
  minOrderAmount: number | null;
  freeDeliveryFrom: number | null;
  defaultPaymentTerms: PaymentTerms;
  defaultDeferDays: number | null;

  /** Заявки ведутся полностью в 1С — кабинет прячет ручные действия и не даёт их продублировать. */
  ordersManagedInErp: boolean;
  /** Режим разработчика: временно разрешает править поля, которые обычно блокирует 1С. */
  erpDeveloperMode: boolean;

  subscriptionStatus: SubStatus;
  trialEndsAt: string | null;
  currentPeriodEnd: string | null;
  createdAt: string;
  updatedAt: string;
  lastLoginAt: string | null;
}

export const getMe = () => get<SupplierProfile>('/me');

export const updateMe = (body: Partial<SupplierProfile>) =>
  patch<SupplierProfile>('/me', body);
